import { useIntl } from 'react-intl';
import { Box, Typography } from '@packages/shared';
import { useRouter } from 'next/router';
import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData, graphql } from '@packages/gql/generated/shopping';
import { voucherPriceMessages } from './messages';
import { extractQueryParameter } from '../../helpers/extractQueryParameter';
import { usePriceFormater } from '../../hooks/usePriceFormater';

const VoucherPriceFragment = graphql(/* GraphQL */ `
  fragment VoucherPriceFragment on ProductPrice {
    currency
    value
  }
`);

export type VoucherPriceProps = {
  data: FragmentType<typeof VoucherPriceFragment>;
};

/**
 * <p>This component renders a voucher price, also called "Geizhals Einsprung".</p>
 * */
export const VoucherPrice = ({ data }: VoucherPriceProps) => {
  const { value, currency } = getFragmentData(VoucherPriceFragment, data);
  const { query } = useRouter();
  const { voucherPriceDiscount } = extractQueryParameter(query);
  const { formatMessage } = useIntl();
  const formatPrice = usePriceFormater('PRODUCT');

  if (!voucherPriceDiscount) {
    return null;
  }

  return (
    <Box>
      <Typography
        variant="h4"
        sx={{
          color: 'sale.main',
          fontWeight: 'fontWeightBold',
        }}
      >
        {formatMessage(voucherPriceMessages.DiscountPriceText, {
          price: formatPrice((value * ((100 - voucherPriceDiscount) / 100)) / 100, currency),
        })}
      </Typography>
      <Typography
        sx={{
          typography: 'body3',
          color: 'text.darkTransparent',
        }}
      >
        {formatMessage(voucherPriceMessages.DiscountSubtext)}
      </Typography>
    </Box>
  );
};
